//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignPromptDialog from '@/components/SignPromptDialog';

export default {
    constants: {
        contactPersonColumnDefs: [
            ['name', true, 'text', r => [r.title, r.firstName, r.lastName].filter(v => v).join(' ')],
            ['position', true, 'text'],
            ['email', true, 'email'],
            ['phone', true, 'tel'],
        ],
        driverColumnDefs: [
            ['title', true, 'text'],
            ['firstName', true, 'text'],
            ['lastName', true, 'text'],
        ],
    },

    data() {
        return {
            leftTab: '1',
            subTab: '1',
            step: '1',
            filterBranch: null,
            extraVehicleProps: null,
            ignoreDatesInVehicleSelect: false,
            createdContactPerson: null,
            createdDriver: null,
            contactPersonsDirty: false,
            unwatchers: [],
            errors: {
                from: false,
                to: false,
                vehicle: false,
            },
            steps: {
                1: null,
                2: null,
                3: null,
                4: null,
            },
            signing: false,
        };
    },

    watch: {
        leftTab() {
            this.subTab = '1';
        },
        step() {
            this.subTab = '1';
        },
    },

    methods: {
        tContract1(item) {
            return this.hasRs(item) ? 'Počáteční dodatek' : 'Smlouva';
        },
        tContract2(item) {
            return this.hasRs(item) ? 'počátečního dodatku' : 'smlouvy';
        },
        tContract4(item) {
            return this.hasRs(item) ? 'počáteční dodatek' : 'smlouvu';
        },
        detailTitleFn(item, editItem) {
            if (!editItem)
                return '';

            if (!item) {
                const prefix = $.t(`nu.cases${this.$route.query.internal == 1 ? '.internal' : ''}`);
                const days = $.getCaseLengthInDays(editItem.from, editItem.to);
                const daysPart = days > 0 ? ` (${days} ${this.$tc('days', days)})` : '';

                return `${prefix}${daysPart}`;
            }

            const prefix = (
                item.isInternal ? 'Interní rezervace' :
                item.contract.signed ? 'Zápůjčka' :
                'Rezervace'
            );

            const days = $.getCaseLengthInDays(editItem.from || item.from, editItem.to || item.to);
            const dateRange = $.formatDateRange(editItem.from || item.from, editItem.to || item.to);
            const datePart = days > 0 ? ` ${days} ${this.$tc('days', days)} (${dateRange})` : '';

            return `${prefix}${datePart} ${this.getVehicleNameLong(item.vehicle)}`;
        },
        async validateFn(item, editItem) {
            if (editItem.contract?.signed && editItem.vehicle.condition !== item.vehicle.condition) {
                await $.updateOne('vehicles', {
                    id: editItem.vehicle.id,
                    condition: editItem.vehicle.condition,
                });
            }

            return true;
        },
        getVehicleCellValue(vehicle) {
            return [
                [vehicle.make, vehicle.model].filter(x => x).join(' '),
                [vehicle.variant, vehicle.rz || vehicle.vin].filter(x => x).join(' | '),
            ];
        },
        getVehicleNameLong(vehicle) {
            return [vehicle.make, vehicle.model, vehicle.variant, vehicle.rz].filter(x => x).join(' ');
        },
        getUserName(user) {
            return user && `${user.firstName} ${user.lastName}`;
        },
        getClientName(client) {
            this.$refs.master.actualizeRefSkipDirty('clients', client, 'personRef');

            return client && (client.person ? `${client.person.firstName} ${client.person.lastName}` : client.companyName);
        },
        getClientWithContactPersons(client) {
            this.$refs.master.actualizeRefSkipDirty('clients', client, 'contactPersonRefs');

            return client;
        },
        getPersonName(person) {
            return `${person.firstName} ${person.lastName}`;
        },
        getTypeStatusCell(item) {
            return (
                item.isInternal ? 'interní rezervace' :
                item.closed ? 'uzavřena' :
                item.protocolIn.signed ? debug.assert(false, () => `Protocol in signed but case not closed for case with ID ${item.id}.`) :
                item.contract.terminated ? 'předčasně ukončena, čeká se na vrácení' :
                item.protocolOut.signed ? 'aktivní zápůjčka' :
                item.contract.signed ? (this.hasRs(item) ? 'počáteční dodatek podepsán' : 'smlouva podepsána') :
                item.contract.generated ? (this.hasRs(item) ? 'počáteční dodatek připraven' : 'smlouva připravena') :
                'rezervace'
            );
        },
        getIntervalIndex(from, to, vehicle) {
            const category = vehicle?.category;
            const prices = category?.dailyPrices;
            const intervalTos = category?.intervalSet?.values;

            // If dates or category or intervals or prices not set, return -1
            if (!from || !to || !prices?.length || !intervalTos?.length)
                return -1;

            const days = $.getCaseLengthInDays(from, to);

            // If number of days falls below first interval, return -1
            if (intervalTos[0] + 1 > days)
                return -1;

            return intervalTos.findIndex(v => v >= days);
        },
        getDailyPrice(item) {
            const idx = this.getIntervalIndex(item.from, item.to, item.vehicle);

            if (idx === -1)
                return null;

            return item.vehicle.category.dailyPrices[idx - 1];
        },
        getFallbackPrice(item) {
            this.$refs.master.actualizeRefSkipDirty('vehicles', item.vehicle, 'categoryRef');
            this.$refs.master.actualizeRefSkipDirty('vehicleCategories', item.vehicle.category, 'intervalSetRef');

            return (
                item.typPujcovneho === 'daily' ? this.getDailyPrice(item) :
                item.typPujcovneho === 'monthly' ? item.vehicle?.category?.monthlyPrice :
                null
            );
        },
        getFallbackKmLimit(item) {
            this.$refs.master.actualizeRefSkipDirty('vehicles', item.vehicle, 'categoryRef');
            this.$refs.master.actualizeRefSkipDirty('vehicleCategories', item.vehicle.category, 'intervalSetRef');

            return (
                item.typPujcovneho === 'daily' ? item.vehicle?.category?.dailyKmLimit :
                item.typPujcovneho === 'monthly' ? item.vehicle?.category?.monthlyKmLimit :
                null
            );
        },
        getPricePerExtraKm(item) {
            this.$refs.master.actualizeRefSkipDirty('vehicles', item.vehicle, 'categoryRef');
            this.$refs.master.actualizeRefSkipDirty('vehicleCategories', item.vehicle.category, 'intervalSetRef');

            return item.vehicle?.category?.pricePerExtraKm;
        },
        getFinalPrice(item) {
            return (
                item.typPujcovneho === 'daily' ? (item.price || this.getDailyPrice(item)) * $.getCaseLengthInDays(item.from, item.to) :
                item.typPujcovneho === 'monthly' ? Math.round((item.price || item.vehicle?.category?.monthlyPrice) * $.getCaseLengthInMonths(item.from, item.to)) :
                null
            );
        },
        getFinalKmLimit(item) {
            return (
                item.totalKmLimit ? item.totalKmLimit :
                item.typPujcovneho === 'daily' ? (item.kmLimit || item.vehicle?.category?.dailyKmLimit) * $.getCaseLengthInDays(item.from, item.to) :
                item.typPujcovneho === 'monthly' ? Math.round((item.kmLimit || item.vehicle?.category?.monthlyKmLimit) * $.getCaseLengthInMonths(item.from, item.to)) :
                null
            );
        },
        // Returns filter function for vehicle select in case wizard
        getVehicleFilter(item) {
            this.$refs.master.actualizeRefSkipDirty('vehicles', null, 'categoryRef');
            this.$refs.master.actualizeRefSkipDirty('vehicleCategories', null, 'intervalSetRef');

            return v => (
                // Apply branch filter
                (!this.filterBranch || v.allBranches || v.branchRef === this.filterBranch.id) &&
                // Apply interval set filter
                (this.ignoreDatesInVehicleSelect || this.getIntervalIndex(item.from, item.to, v) !== -1) &&
                // Check if vehicle available in specified date range
                (
                    // No dates selected
                    (!item.from && !item.to) ||
                    // At least one date selected - check vehicle has no cases overlapping current case
                    $.cases.every(c => !this.isCaseOverlapWith(item, c, v))
                )
            );
        },
        getAmendmentDateLabel(a) {
            return (
                a.signed ? null :
                a.generated ? `Připraven k podpisu ${$.formatDateTime(a.generated)}` :
                a.updated !== a.started ? `Doplněn ${$.formatDateTime(a.updated)}` :
                `Započat ${$.formatDateTime(a.started)}`
            );
        },
        // Get signedBy options for contract or amendment, i.e. client-person or contact persons
        getContractSigners(editItem, doc) {
            if (editItem.client.personRef)
                return [$.findById(doc.snapshot.persons, doc.snapshot.client.personRef)];

            return doc.snapshot.client.contactPersonRefs.map(ref => $.findById(doc.snapshot.persons, ref.id));
        },
        getSignedByStr(doc) {
            return this.getPersonName($.findById(doc.snapshot.persons, doc.signedByRef));
        },
        // Returns disabled dates for 'from' and 'to' date pickers in case wizard/detail
        getDisabledDates(editItem) {
            const allowPast = $.getSetting('createPastCases');

            let dateRanges = [];

            if (!allowPast) {
                // If creating cases in the past is not allowed, disable all days <= yesterday
                dateRanges.push({
                    start: null,
                    end: dayjs().subtract(1, 'day').valueOf(),
                });
            }

            if (editItem.vehicleRef) {
                this.$refs.master.actualizeRefSkipDirty('cases', editItem, 'vehicleRef');
                this.$refs.master.actualizeRefSkipDirty('vehicles', editItem.vehicle, 'categoryRef');

                const serviceDays = editItem.vehicle.category.serviceDays;
                const cases = $.cases.filter(c => (
                    // Case is not currently edited case
                    c.id !== editItem.id &&
                    // Case has same vehicle as currently edited case
                    c.vehicleRef === editItem.vehicleRef &&
                    // If creating cases in the past is not allowed, past cases can be filtered out here
                    (allowPast || !this.isCasePast(c, serviceDays))
                ));

                // Disable day ranges corresponding to conflicting cases
                dateRanges.push(...cases.map(c => ({
                    start: dayjs(c.from).subtract(serviceDays, 'day').valueOf(),
                    end: dayjs(c.closed || c.to).add(serviceDays, 'day').valueOf(),
                })));
            }

            return dateRanges;
        },
        // Returns whether case ends in the past
        // Granularity: days; includes service period
        isCasePast(c, serviceDays = 0) {
            // Vehicles with no service period are freed up immediately on case closure
            if (c.closed && !serviceDays)
                // Note: In real life, this will always equal true
                return dayjs(c.closed).isBefore();

            // Check if there were enough whole (midnight-to-midnight) service days between case end and now
            return dayjs(c.closed || c.to).add(serviceDays, 'day').isBefore(dayjs(), 'day');
        },
        // Returns whether current case overlaps with another case
        // Granularity: days; includes service period
        isCaseOverlapWith(current, other, vehicle = current.vehicle) {
            this.$refs.master.actualizeRefSkipDirty('vehicles', vehicle, 'categoryRef');

            return (
                // Case is not currently edited case
                other.id !== current.id &&

                // Case has vehicle being checked
                other.vehicleRef === vehicle.id &&

                // Optional: If creating cases in the past is not allowed, past cases can be filtered out here
                // TODO: Might make use of an 'isPast' flag here for it to become an actual optimization
                // ($.getSetting('createPastCases') || !this.isCasePast(other, vehicle.category.serviceDays)) &&

                (
                    // No date specified - no overlap
                    // Note: redundant as of now, but that's ok
                    (!current.from && !current.to) ||

                    // Both dates specified - check if case date ranges overlap (including service period)
                    (current.from && current.to && this.isDateRangesOverlap(
                        current.from,
                        current.to,
                        other.from,
                        other.closed || other.to,
                        vehicle.category.serviceDays,
                    )) ||

                    // Only one date specified - check if it falls within other case's date range (including service period)
                    this.isDateInRange(
                        current.from || current.to,
                        other.from,
                        other.closed || other.to,
                        vehicle.category.serviceDays,
                    )
                )
            );
        },
        // Returns whether date falls within range
        // Granularity: days; includes service period
        isDateInRange(date, from, to, serviceDays) {
            return this.isDateRangesOverlap(date, date, from, to, serviceDays);
        },
        // Returns whether two date ranges overlap
        // Granularity: days; includes service period
        isDateRangesOverlap(from1, to1, from2, to2, serviceDays) {
            return (
                dayjs(from1).subtract(serviceDays, 'day').isSameOrBefore(to2, 'day') &&
                dayjs(from2).subtract(serviceDays, 'day').isSameOrBefore(to1, 'day')
            );
        },
        isDriverOfClient(item, person) {
            return item.client?.driverRefs.includes(person.id);
        },
        isContactPersonOfClient(item, person) {
            return item.client?.person
                ? person.id === item.client.personRef
                : item.client?.contactPersonRefs.some(ref => ref.id === person.id);
        },
        isContractSigned(item) {
            return item && !item.isInternal && item.contract.signed;
        },
        isContractEnded(item) {
            return item && (item.closed || item.contract.terminated);
        },
        hasRs(item) {
            return !!item.client?.rsFrom;
        },
        hasUnsignedAmendment(item) {
            return item.amendments.some(a => !a.signed);
        },
        checkAndClearVehicleOnDateChanges(editItem) {
            const checkFn = () => this.checkAndClearVehicle(editItem);

            this.unwatchers.push(this.$watch(() => editItem.from, checkFn));
            this.unwatchers.push(this.$watch(() => editItem.to, checkFn));
            this.unwatchers.push(this.$watch('filterBranch', checkFn));
            this.unwatchers.push(this.$watch('ignoreDatesInVehicleSelect', checkFn));
        },
        checkAndClearVehicle(editItem) {
            const filter = this.getVehicleFilter(editItem);

            if (editItem.vehicle && !filter(editItem.vehicle)) {
                editItem.vehicleRef = null;
                editItem.vehicle = null;
            }

            this.extraVehicleProps = (!editItem.from || !editItem.to || $.vehicles.some(filter)) ? null : {
                label: `V zadaném rozmezí dat není${this.filterBranch ? ' na vybrané pobočce' : ''} k dispozici žádné vozidlo.`,
                disable: true,
            };
        },
        unwatchAll() {
            this.unwatchers.forEach(fn => fn());
            this.unwatchers.splice(0);
        },
        stepProps(step) {
            return {
                name: step,
                prefix: step,
                error: this.steps[step] === false,
                done: this.steps[step] === true,
                'header-nav': this.steps[step] === true || this.steps[step - 1] === true || this.step == step - 1,
            };
        },
        async goToStep(step, editItem) {
            if (await this.validateReservation(editItem)) {
                this.step = step;
            }
        },
        prevStep() {
            this.$refs.stepper.previous();
        },
        async nextStep(editItem) {
            if (await this.validateReservation(editItem)) {
                this.$refs.stepper.next();
            }
        },
        onlyOwnerChanged(item, editItem) {
            const omittables = ['vehicle', 'client', 'owner', 'drivers', 'contract', 'protocolOut', 'protocolIn', 'amendments'];
            const { added, removed, modified } = diff(_.omit(item, omittables), _.omit(editItem, omittables));
            const combinedDiff = [...added, ...removed, ...modified];

            return combinedDiff.length === 1 && combinedDiff[0].field === 'ownerRef';
        },
        async saveRental(item, editItem, update) {
            // If only owner changed, skip amendment processing, save and quit
            if (this.onlyOwnerChanged(item, editItem)) {
                await update();

                return;
            }

            // Shallow validation
            // Note: 'Shallow' means that it skips related data (e.g. drivers' cisloRp)
            // that can be fixed elsewhere in the time before the amendment is generated
            if (!(await this.validateForAmendment(editItem, false)))
                return;

            // Force unsigned protocol out to be re-generated once amendment is signed or discarded
            if (editItem.protocolOut.generated && !editItem.protocolOut.signed) {
                editItem.protocolOut.generated = null;
            }

            // Force unsigned protocol in to be re-generated once amendment is signed or discarded
            if (editItem.protocolIn.generated && !editItem.protocolIn.signed) {
                editItem.protocolIn.generated = null;
            }

            let amendment = _.last(editItem.amendments);

            if (!amendment || amendment.signed) {
                amendment = this.startAmendment(editItem);
            }

            amendment.diff = true;
            amendment.updated = Date.now();
            amendment.generated = null;

            await update();

            this.leftTab = '5';
            this.subTab = '1';

            // Once on last tab, scroll down to amendments
            // Note: Commented out due to obsolete ref
            // this.$nextTick(() => {
            //     this.$refs.master.$refs.detail.$refs.scroll.setScrollPosition(9999);
            // });
        },
        async saveReservation(item, editItem, create, update) {
            if (!(await this.validateReservation(editItem)))
                return;

            const generated = editItem.contract?.generated;

            if (generated) {
                editItem.contract.snapshot = null;
                editItem.contract.generated = null;
            }

            if (item) {
                await update();
            } else {
                await create();
            }

            if (generated) {
                this.step = '5';
            }
        },
        async saveClientContactPersons(editItem) {
            if (editItem.client) {
                editItem.client = await $.updateOne('clients', _.pick(editItem.client, 'id', 'contactPersonRefs'), true);

                this.contactPersonsDirty = false;
            }
        },
        async validateReservation(editItem) {
            $.setAll(this.errors, false);

            // This causes the bounce animation on fields with errors
            // to be triggered again on repeated validation
            await $.delay(0);

            if (this.step === '5')
                return true;

            if (this.step === '1') {
                this.errors.from = (
                    (!editItem.from && 'Chybí počáteční datum')/* ||
                    (dayjs(editItem.from).isBefore() && 'Počáteční datum je v minulosti')*/
                );

                this.errors.to = (
                    (!editItem.to && 'Chybí koncové datum') ||
                    (dayjs(editItem.to).isBefore(editItem.from) && 'Koncové datum je před počátečním')
                );

                this.errors.vehicle = (
                    (!editItem.vehicle && 'Chybí vozidlo') ||
                    (editItem.from && editItem.to && $.cases.some(c => this.isCaseOverlapWith(editItem, c)) && 'Vozidlo není v daném rozmezí dostupné')
                );

                this.steps[this.step] = !Object.values(this.errors).find(e => e);
            } else if (this.step === '2') {
                // If client is person and no drivers are set (yet), add client person as driver
                if (editItem.client?.personRef && !editItem.driverRefs.length) {
                    editItem.driverRefs.push(editItem.client.personRef);
                    editItem.drivers.push(editItem.client.person || findById($.persons, editItem.client.personRef));
                }

                this.steps[this.step] = true;
            } else {
                this.steps[this.step] = true;
            }

            return this.steps[this.step];
        },
        async validateForContract(editItem) {
            // TODO: Mark fields and steps as erroneous
            // TODO: vehicle, client, driver fields; prices, limits

            let errors = [];

            if (!editItem.client) {
                errors.push('Musí být přiřazen klient.');
            }

            if (!editItem.drivers.length) {
                errors.push('Musí být přiřazen alespoň jeden řidič.');
            }

            const driversNoRp = editItem.drivers.filter(p => !p.cisloRp/* || !p.scanRp*/);

            if (driversNoRp.length) {
                errors.push(`Řidiči s chybějícím řidičským průkazem: ${driversNoRp.map(this.getPersonName)}`);
            }

            if (!errors.length)
                return true;

            return await new Promise(resolve => {
                this.$q.dialog({
                    title: `${this.hasRs(editItem) ? 'Počáteční dodatek' : 'Smlouvu'} nelze vygenerovat`,
                    message: errors.join('<br>'),
                    html: true,
                }).onOk(() => resolve(false));
            });
        },
        async validateForAmendment(editItem, deep) {
            // TODO: Mark fields and steps as erroneous
            // TODO: driver fields

            let errors = [];

            const to = $.getLatestSnapped(editItem, 'case.to');

            if (editItem.to < to) {
                errors.push('Zápůjčku nelze zkrátit.');
            } else if (editItem.to !== to && $.cases.some(c => this.isCaseOverlapWith(editItem, c))) {
                errors.push('Zápůjčku nelze prodloužit - vozidlo je už v daném termínu zarezervováno.');
            }

            if (!editItem.drivers.length) {
                errors.push('Musí být přiřazen alespoň jeden řidič.');
            }

            if (deep) {
                const driversNoRp = editItem.drivers.filter(p => !p.cisloRp/* || !p.scanRp*/);

                if (driversNoRp.length) {
                    errors.push(`Řidiči s chybějícím řidičským průkazem: ${driversNoRp.map(this.getPersonName)}`);
                }
            }

            if (!errors.length)
                return true;

            return await new Promise(resolve => {
                this.$q.dialog({
                    title: 'Dodatek nelze potvrdit',
                    message: errors.join('<br>'),
                    html: true,
                }).onOk(() => resolve(false));
            });
        },
        startAmendment(editItem) {
            const amendment = {
                snapshot: null,
                diff: null,
                started: Date.now(),
                updated: Date.now(),
                generated: null,
                signed: null,
            };

            editItem.amendments.push(amendment);

            return amendment;
        },
        discardAmendment(editItem) {
            const amendment = editItem.amendments.pop();

            debug.assert(amendment, () => `Discarding amendment when there is none for case with ID ${editItem.id}`);
            debug.assert(!amendment.signed, () => `Discarding signed amendment for case with ID ${editItem.id}: ${amendment}`);

            // Reset data to previous snapshot

            const prevTo = $.getLatestSnapped(editItem, 'case.to');
            const prevDriverRefs = $.getLatestSnapped(editItem, 'case.driverRefs');

            editItem.to = prevTo;
            editItem.driverRefs = prevDriverRefs;
            editItem.drivers = null;
        },
        async doGenerateContract(editItem, create, update) {
            if (!(await this.validateForContract(editItem)))
                return;

            // Prices and limits - write inherited values through to case
            $.setIfEmpty(editItem, 'deposit', editItem.vehicle.deposit);
            $.setIfEmpty(editItem, 'price', this.getFallbackPrice(editItem));
            $.setIfEmpty(editItem, 'kmLimit', this.getFallbackKmLimit(editItem));
            $.set(editItem, 'pricePerExtraKm', this.getPricePerExtraKm(editItem));

            editItem.contract.snapshot = true;

            if (editItem.id) {
                await update();
            } else {
                await create();
            }
        },
        async doUngenerateContract({ editItem, update }) {
            editItem.contract.snapshot = null;
            editItem.contract.generated = null;

            await update();
        },
        async doSignContract({ editItem, update, date, signedBy }) {
            editItem.contract.signed = date;
            editItem.contract.signedByRef = signedBy.id;

            await update();

            this.leftTab = '5';
        },
        async doTerminateContract(editItem, update) {
            // Note: We're using SignPromptDialog just for the date here; no signing is involved
            this.$q.dialog({
                component: SignPromptDialog,
                parent: this,
                title: 'Předčasné ukončení zápůjčky',
                message: 'Vyberte datum a čas:',
                noSignedBy: true,
            }).onOk(async ({ date }) => {
                // If there is unsigned amendment, discard it first
                if (this.hasUnsignedAmendment(editItem)) {
                    this.discardAmendment(editItem);
                }

                editItem.contract.terminated = date;

                if (!editItem.protocolOut.signed) {
                    editItem.closed = date;
                }

                await update();
            });
        },
        async doGenerateProtocolOut(editItem, update) {
            editItem.protocolOut.snapshot = true;

            // Store odometer at start of rental for limit checking
            editItem.kmStartOfDay = editItem.vehicle.odometer;
            editItem.kmStartOfMonth = editItem.vehicle.odometer;
            editItem.kmStartOfRental = editItem.vehicle.odometer;

            await update();
        },
        async doUngenerateProtocolOut({ editItem, update }) {
            editItem.protocolOut.snapshot = null;
            editItem.protocolOut.generated = null;

            await update();
        },
        async doSignProtocolOut({ editItem, update, date, signedBy }) {
            editItem.protocolOut.signed = date;
            editItem.protocolOut.signedByRef = signedBy.id;

            await update();
        },
        async doGenerateProtocolIn(editItem, update) {
            editItem.protocolIn.snapshot = true;

            await update();
        },
        async doUngenerateProtocolIn({ editItem, update }) {
            editItem.protocolIn.snapshot = null;
            editItem.protocolIn.generated = null;

            await update();
        },
        async doSignProtocolIn({ editItem, update, date, signedBy }) {
            // If there is unsigned amendment, discard it first
            if (this.hasUnsignedAmendment(editItem)) {
                this.discardAmendment(editItem);
            }

            editItem.protocolIn.signed = date;
            editItem.protocolIn.signedByRef = signedBy.id;
            editItem.closed = date;

            await update();
        },
        async doDiscardAmendment(editItem, update) {
            this.discardAmendment(editItem);

            await update();
        },
        async doGenerateAmendment(editItem, update) {
            if (!(await this.validateForAmendment(editItem, true)))
                return;

            const amendment = _.last(editItem.amendments);

            amendment.snapshot = true;

            await update();
        },
        async doUngenerateAmendment({ editItem, update }) {
            const amendment = _.last(editItem.amendments);

            amendment.snapshot = null;
            amendment.generated = null;

            await update();
        },
        async doSignAmendment({ editItem, update, date, signedBy }) {
            const amendment = _.last(editItem.amendments);

            amendment.signed = date;
            amendment.signedByRef = signedBy.id;

            await update();
        },
        async doResetContract(editItem, update) {
            editItem.to = editItem.contract.snapshot.case.to;
            editItem.driverRefs = editItem.contract.snapshot.case.driverRefs;
            editItem.drivers = null;

            editItem.photosOut.forEach(p => p.removed = true);
            editItem.photosIn.forEach(p => p.removed = true);

            editItem.contract = {};
            editItem.protocolOut = {};
            editItem.protocolIn = {};

            editItem.amendments = [];

            editItem.closed = null;

            await update();

            this.step = '5';
        },
        async downloadTerms() {
            const filename = 'vseobecne_obchodni_podminky.pdf';
            const { data } = await axios.get(`/terms`, { responseType: 'blob' });

            $.downloadBlob(data, filename);
        },
        async downloadPdf(item, type, suffix, amendmentIndex) {
            const { id: caseId, code } = item;
            const { data } = await axios.post('/doc/pdf', { caseId, type, amendmentIndex }, { responseType: 'blob' });

            $.downloadBlob(data, `${code}_${suffix}.pdf`);
        },
        async downloadContract(item) {
            await this.downloadPdf(
                item,
                this.hasRs(item) ? 'initialAmendment' : 'contract',
                this.hasRs(item) ? 'pocatecni_dodatek' : 'smlouva',
            );
        },
        async downloadAmendment(item, index) {
            await this.downloadPdf(item, 'amendment', `dodatek_${index + 1}`, index);
        },
        async downloadProtocolOut(item) {
            await this.downloadPdf(item, `protocolOut`, 'predavaci_protokol');
        },
        async downloadProtocolIn(item) {
            await this.downloadPdf(item, `protocolIn`, 'protokol_o_vraceni');
        },
        async onDetailInit(item, editItem) {
            this.unwatchAll();

            // Wizard-only
            if (!this.isContractSigned(item)) {
                // Note: This should now be obsolete since live date disabling and vehicle filtering were implemented
                this.checkAndClearVehicleOnDateChanges(editItem);

                // Filter vehicles by current user's branch by default
                if ($.currentUser.branchRef && !editItem.vehicleRef) {
                    this.filterBranch = $.findById($.branches, $.currentUser.branchRef);
                }

                // Initialize internal case
                if (!item && this.$route.query.internal == 1) {
                    $.set(editItem, 'isInternal', true);
                }

                // Initalize new case owner to current user
                if (!item) {
                    $.set(editItem, 'owner', $.currentUser);
                    $.set(editItem, 'ownerRef', $.currentUser.id);
                }

                $.setAll(this.steps, item ? true : null);

                if (item) {
                    await this.validateReservation(editItem);
                }
            }
        },
        onDetailClosing() {
            this.unwatchAll();

            this.filterBranch = null;
            this.createdContactPerson = null;
            this.createdDriver = null;
            this.contactPersonsDirty = false;

            $.setAll(this.errors, false);
        },
        onSetClient(editItem, client) {
            this.contactPersonsDirty = false;

            if (client?.person && !editItem.guarantor) {
                editItem.guarantor = client.person;
                editItem.guarantorRef = client.personRef;
            }
        },
        onCreateClient(editItem, client) {
            editItem.client = client;
            editItem.clientRef = client.id;

            this.subTab = '1';
        },
        onCreateContactPerson(editItem, person) {
            this.subTab = '1';
            this.createdContactPerson = person;
        },
        onCreateDriver(editItem, person) {
            this.subTab = '1';
            this.createdDriver = person;
        },
    },
};
